import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardBody } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Building2, FileCheck, Clock, HeartPulse, CheckCircle } from 'lucide-react';
export function Partners() {
  return <div className="bg-white min-h-screen" data-id="element-883">
      {/* Header */}
      <div className="bg-primary-900 text-white py-20" data-id="element-884">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-885">
          <div className="max-w-3xl" data-id="element-886">
            <span className="text-primary-300 font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-887">
              For Healthcare Facilities & Providers
            </span>
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-888">
              Affordable Logistics for Your Care Team
            </h1>
            <p className="text-xl text-primary-100 mb-8" data-id="element-889">
              Partner with Gozie Transportation to ensure your patients arrive
              safely, and your medical equipment is shipped securely, all at
              rates that respect your facility's budget.
            </p>
            <Button size="lg" variant="secondary" data-id="element-890">
              Request a Partnership Packet
            </Button>
          </div>
        </div>
      </div>

      {/* Why Partner */}
      <div className="py-20 bg-warm-50" data-id="element-891">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-892">
          <div className="text-center mb-16" data-id="element-893">
            <h2 className="text-3xl font-bold text-warm-900 mb-4" data-id="element-894">
              Why Facilities Choose Us
            </h2>
            <p className="text-lg text-warm-600 max-w-2xl mx-auto" data-id="element-895">
              We understand the challenges of patient logistics. Missed
              appointments and delayed equipment shipping cost time, money, and
              impact health outcomes.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-896">
            <Card className="border-none shadow-md" data-id="element-897">
              <CardBody className="text-center p-6" data-id="element-898">
                <Clock className="w-10 h-10 text-primary-600 mx-auto mb-4" data-id="element-899" />
                <h3 className="text-xl font-bold text-warm-900 mb-2" data-id="element-900">
                  On-Time Reliability
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-901">
                  Reduce missed appointments and late arrivals with our advanced
                  dispatch and routing technology.
                </p>
              </CardBody>
            </Card>
            <Card className="border-none shadow-md" data-id="element-902">
              <CardBody className="text-center p-6" data-id="element-903">
                <FileCheck className="w-10 h-10 text-primary-600 mx-auto mb-4" data-id="element-904" />
                <h3 className="text-xl font-bold text-warm-900 mb-2" data-id="element-905">
                  HIPAA Compliant
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-906">
                  Strict adherence to privacy laws. Secure booking portals and
                  trained staff protect patient information.
                </p>
              </CardBody>
            </Card>
            <Card className="border-none shadow-md" data-id="element-907">
              <CardBody className="text-center p-6" data-id="element-908">
                <HeartPulse className="w-10 h-10 text-primary-600 mx-auto mb-4" data-id="element-909" />
                <h3 className="text-xl font-bold text-warm-900 mb-2" data-id="element-910">
                  Trained Staff
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-911">
                  Drivers are CPR/First Aid certified and trained in safe
                  transfer techniques and patient sensitivity.
                </p>
              </CardBody>
            </Card>
            <Card className="border-none shadow-md" data-id="element-912">
              <CardBody className="text-center p-6" data-id="element-913">
                <Building2 className="w-10 h-10 text-primary-600 mx-auto mb-4" data-id="element-914" />
                <h3 className="text-xl font-bold text-warm-900 mb-2" data-id="element-915">
                  Dedicated Portal
                </h3>
                <p className="text-warm-600 text-sm" data-id="element-916">
                  Facility coordinators get access to a streamlined dashboard to
                  book, track, and manage all patient rides.
                </p>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>

      {/* Contract Services */}
      <div className="py-20" data-id="element-917">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-918">
          <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-919">
            <div className="lg:w-1/2" data-id="element-920">
              <h2 className="text-3xl font-bold text-warm-900 mb-6" data-id="element-921">
                Affordable Contract Solutions
              </h2>
              <p className="text-lg text-warm-600 mb-6" data-id="element-922">
                We offer heavily discounted, customized contracts for hospitals,
                nursing homes, adult day centers, and clinics needing passenger
                transport or equipment shipping.
              </p>
              <ul className="space-y-4 mb-8" data-id="element-923">
                <li className="flex items-start" data-id="element-924">
                  <CheckCircle className="w-6 h-6 text-secondary-600 mr-3 flex-shrink-0" data-id="element-925" />
                  <div data-id="element-926">
                    <strong className="block text-warm-900" data-id="element-927">
                      Discounted Dedicated Routes
                    </strong>
                    <span className="text-warm-600" data-id="element-928">
                      Set daily or weekly schedules for recurring patient needs
                      or equipment deliveries at our lowest rates.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-929">
                  <CheckCircle className="w-6 h-6 text-secondary-600 mr-3 flex-shrink-0" data-id="element-930" />
                  <div data-id="element-931">
                    <strong className="block text-warm-900" data-id="element-932">
                      Streamlined Billing
                    </strong>
                    <span className="text-warm-600" data-id="element-933">
                      Consolidated monthly invoicing or direct
                      insurance/Medicaid billing where applicable.
                    </span>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-934">
                  <CheckCircle className="w-6 h-6 text-secondary-600 mr-3 flex-shrink-0" data-id="element-935" />
                  <div data-id="element-936">
                    <strong className="block text-warm-900" data-id="element-937">
                      Priority Dispatch
                    </strong>
                    <span className="text-warm-600" data-id="element-938">
                      Contracted facilities receive priority status for urgent,
                      same-day transport needs (like hospital discharges).
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            <div className="lg:w-1/2 w-full" data-id="element-939">
              <Card className="shadow-xl" data-id="element-940">
                <CardBody className="p-8" data-id="element-941">
                  <h3 className="text-2xl font-bold text-warm-900 mb-6" data-id="element-942">
                    Contact Our Provider Relations Team
                  </h3>
                  <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-943">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-944">
                      <Input label="First Name" required data-id="element-945" />
                      <Input label="Last Name" required data-id="element-946" />
                    </div>
                    <Input label="Facility/Organization Name" required data-id="element-947" />
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-948">
                      <Input label="Work Email" type="email" required data-id="element-949" />
                      <Input label="Direct Phone" type="tel" required data-id="element-950" />
                    </div>
                    <Input label="How can we help?" multiline placeholder="Tell us about your facility's transportation volume and needs..." data-id="element-951" />
                    <Button type="submit" fullWidth size="lg" className="mt-4" data-id="element-952">
                      Submit Inquiry
                    </Button>
                  </form>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>;
}